import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * The contractor portal's guard: contractors only. Everyone else goes back to
 * the system (PrivateRoute sends contractors the other way).
 */
const ContractorRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'contractor') return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
};

export default ContractorRoute;
